import React, { useEffect } from "react";
import "./areasdependencia.css";

const Areasdependencia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container areasdependencia-container">
      <div className='row'>
            <div className='col_12'>
                <div className='areasdependencia_title'>
                    <h1>Servicios</h1>
                </div>
            </div>
        </div>
      
      <hr className="hr-gob" />
    </div>
  );
};

export default Areasdependencia;
